module.exports = __webpack_public_path__ + "img/inspectingcar.937d35fb.png";